/**
 * Encryption types used for certificate generation
 */

export const EncryptionTypes = {
    // RSA - Asymmetric encryption algorithm
    RSA: 'RSA',
    // EC - Elliptic curve cryptography
    EC: 'EC'
} as const

export type EncryptionTypes = typeof EncryptionTypes[keyof typeof EncryptionTypes];
